module.exports = __webpack_public_path__ + "img/cover_T850.a4559164.png";